import { LinkHTMLAttributes } from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

const StyledLink = styled(Link)<Props>`
  cursor: pointer;
  padding: 12px 24px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: var(--default-text);
  font-weight: 700;
  /* border-radius: 18px; */
  white-space: nowrap;

  text-decoration: none;
`

const PrimaryLink = styled(StyledLink)`
  color: ${({ theme }) => theme.colors.font.white};
  background-color: ${({ theme }) => theme.colors.button.primary};
  /* border: 1px solid ${({ theme }) => theme.colors.brand.primary.regular}; */
  border: none;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.font.inverse};
    /* background-color: ${({ theme }) => theme.colors.brand.primary.hover}; */
    /* border: 1px solid ${({ theme }) => theme.colors.brand.primary.hover}; */
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.brand.primary.active};
    /* border: 1px solid ${({ theme }) => theme.colors.brand.primary.active}; */
  }

  ${(props) =>
    props.disabled &&
    css`
      color: ${({ theme }) => theme.colors.font.disabled};
      background-color: ${({ theme }) =>
        theme.colors.system.interactive.disabled};
      border: 1px solid
        ${({ theme }) => theme.colors.system.interactive.disabled};
      cursor: default;

      &:hover,
      &:focus {
        background-color: ${({ theme }) =>
          theme.colors.system.interactive.disabled};
      }
    `}
`

const SecondaryLink = styled(StyledLink)`
  color: ${({ theme }) => theme.colors.font.regular};
  background-color: ${({ theme }) => theme.colors.button.secondary};
  border: 1px solid ${({ theme }) => theme.colors.button.secondaryBorder};

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.brand.secondary.hover};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.brand.secondary.active};
  }

  ${(props) =>
    props.disabled &&
    css`
      color: ${({ theme }) => theme.colors.font.disabled};
      background-color: ${({ theme }) =>
        theme.colors.system.interactive.disabled};
      border: 1px solid
        ${({ theme }) => theme.colors.system.interactive.disabled};
      cursor: default;

      &:hover,
      &:focus {
        background-color: ${({ theme }) =>
          theme.colors.system.interactive.disabled};
      }
    `}
`

interface Props extends LinkHTMLAttributes<HTMLLinkElement> {
  kind?: 'primary' | 'secondary' | 'warning'
  link?: string
  disabled?: boolean
}

export const ButtonLink: React.FC<Props> = (props) => {
  const { children, className, kind, link, ...rest } = props

  if (link && link !== '') {
    switch (kind) {
      case undefined:
      case 'primary':
        return (
          <PrimaryLink className={className} to={link} {...rest}>
            {children}
          </PrimaryLink>
        )
      case 'secondary':
        return (
          <SecondaryLink className={className} to={link} {...rest}>
            {children}
          </SecondaryLink>
        )
    }
  }
}
